import { SourceItem } from '../../../../../landing.vitrina.product/components/form.params.step/helpers';
import React, { FC, useCallback } from 'react';
import { FORM_FIELDS } from '../../../../../../constants';
import { FormAutoSuggest, anyOptionValue } from '../../../../ui/suggest/auto';
import { Controller, UseFormReturn } from 'react-hook-form';

interface SuggestProps {
    form: UseFormReturn;
    options: SourceItem[];
    onOptionSelect?: (id: SourceItem['name']) => void;
}

export const AutoBrandSuggest: FC<SuggestProps> = (props) => {
    const { form, options, onOptionSelect = () => null } = props;

    const {
        control,
        formState: { errors, dirtyFields: _ },
        setValue,
        getValues,
    } = form;

    const onBrandSelect = useCallback(
        async ({ name: brandId, value: brandName }: SourceItem) => {
            const [formAutoBrandId] = getValues([FORM_FIELDS.AUTO_BRAND_ID]);
            if (formAutoBrandId === brandId) {
                return;
            }

            if (brandId) {
                onOptionSelect(brandId);
            }

            setValue(FORM_FIELDS.AUTO_BRAND, brandName);
            setValue(FORM_FIELDS.AUTO_BRAND_ID, brandId);
            setValue(FORM_FIELDS.AUTO_MODEL, undefined);
            setValue(FORM_FIELDS.AUTO_MODEL_ID, undefined);
            setValue(FORM_FIELDS.AUTO_YEAR, '');
        },
        [setValue, getValues, onOptionSelect],
    );

    return (
        <Controller
            control={control}
            name={FORM_FIELDS.AUTO_BRAND}
            render={({ field: { onBlur, ...field } }) => (
                <FormAutoSuggest
                    input={{
                        ...field,
                        label: 'Марка автомобиля',
                        errorMessage: errors[FORM_FIELDS.AUTO_BRAND]?.message,
                    }}
                    options={options}
                    onSelect={onBrandSelect}
                    onChange={field.onChange}
                    onBlur={onBlur}
                    emptyValue={anyOptionValue}
                />
            )}
        />
    );
};
